import React from 'react';
import { RMHelpURL } from 'utils/Global';
import './Dashboard.scss';
import DashboardBody from './DashboardBody';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { styles } from './Dashboard.styles';
import UpdatesAndNews from './UpdatesAndNews';
import { useRMDispatch } from 'redux/hooks';
import {
  setCheckForUpgrade,
  setShowUpgradeFallbackDialog,
} from 'redux/reducers/commonReducer';
import useRMLite from 'CustomHooks/useRMLite';
import AutoUpdate from 'components/dashboard/AutoUpdate';
import useAppInfo from 'CustomHooks/useAppInfo';

export default function UpdatedDashboard() {
  const dispatch = useRMDispatch();
  const rmLite = useRMLite();
  const appInfo = useAppInfo();
  const appVersion = appInfo?.version;
  const appCopyRights = appInfo?.copyRight;

  return (
    <>
      <div id="updatedashboard-dashboard-body" className="dashboardBody">
        <div
          id="updatedashboard-dashboard-title-row"
          className="dashboardTitleRow w-full gap-2"
        >
          <div id="updatedashboard-dashboard-title" className="dashboardTitle w-full">
            <div
              id="updatedashboard-dashboard-welcome-container"
              style={styles.welcomeMainContainer}
            >
              <RMSvgIcon
                id="updatedashboard-RMLogo"
                name="RMLogo"
                height={'60px'}
                width={'115px'}
                style={styles.RMLogoSvg}
              />
              <div>
                <h2
                  id="updatedashboard-welcome-text-title"
                  style={styles.welcomeTextTitle}
                >
                  Welcome to ROCK MAKER<sup>®</sup> v4
                </h2>
                <p
                  id="updatedashboard-welcome-text-content"
                  style={styles.welcomeTextContainer}
                >
                  ROCK MAKER® is a Laboratory Information Management System (LIMS) that is
                  there every step of the way, with powerful yet easy-to-use tools that
                  help you get the results you need quickly. ROCK MAKER manages the entire
                  crystallization experimentation process, from designing and dispensing
                  to image viewing and analysis.
                </p>
              </div>
            </div>
            <p id="updatedashboard-details-container" style={styles.versioningDiv}>
              Formulatrix Inc. &ensp;Version {appVersion}©{appCopyRights}
            </p>
          </div>
          {!rmLite ? (
            <div
              id="updatedashboard-section-row"
              className="bg-red-100 flex flex-row h-full w-96 gap-2"
            >
              <div id="updatedashboard-updates-news-section" className="w-1/2">
                <UpdatesAndNews
                  title1="Updates"
                  title2="News"
                  svgName="updateNewsLogo"
                  onClick={() => {
                    dispatch(setCheckForUpgrade());
                    dispatch(setShowUpgradeFallbackDialog(true));
                  }}
                />
              </div>
              <div id="updatedashboard-web-help-section" className="w-1/2">
                <UpdatesAndNews
                  title1="Web"
                  title2="Help"
                  svgName="WebHelpLogo"
                  onClick={() => {
                    window.open(RMHelpURL, 'webhelp');
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
        <div id="updatedashboard-dashboard-body-row" className="dashboardBodyRow">
          <DashboardBody />
        </div>
      </div>
      <AutoUpdate showFallback={false} />
    </>
  );
}
